export default __webpack_public_path__ + "static/media/logo-white.7d6a40b9.svg";